/**
 * «Морской бой» — правила и соперник, браузерная половина.
 *
 * Тот же алгоритм, что app/Services/VoiceGames/Games/Battleship/Engine.php,
 * строка в строку: колонка с Алисой и голосовой режим сайта играют в PHP,
 * страница с досками — здесь. Сторож BattleshipEngineParityTest гоняет обе
 * реализации на одних зёрнах (tests/node/battleship-engine-trace.mjs) и
 * требует совпадения каждой расстановки, каждого выстрела соперника и каждого
 * результата. Правка правила — в ОБОИХ файлах.
 *
 * Поле — 100 клеток, индекс = строка × 10 + столбец (строка 0 — «1»,
 * столбец 0 — «А»/«A»). Доска — {s: корабли (списки клеток), m: 100 отметок}:
 *   '.' не стреляли · 'o' мимо · 'x' ранен · 'X' потоплен · '+' пусто по правилам
 * («пусто по правилам» — вокруг потопленного и по диагонали от попадания:
 * корабли прямые и не касаются даже углами).
 *
 * Партия — {lv, rng, b: [доска человека, доска компьютера], par, win}.
 * Случайность — mulberry32 на 32-битной арифметике: зерно определяет партию.
 *
 * Плоский ES5 без сборки; вешает window.BattleshipEngine (и module.exports,
 * если он есть — для node).
 */
(function (root) {
    'use strict';

    var FLEET = [4, 3, 3, 2, 2, 2, 1, 1, 1, 1];
    var LEVELS = ['novice', 'captain', 'admiral'];
    /* Доля выстрелов юнги «куда попало» — и в клетки, где корабля быть не может
       (замер и причина — у константы NOVICE_CARELESS в Engine.php). */
    var NOVICE_CARELESS = 0.5;
    var EMPTY = '....................................................................................................';

    /* ─── Случайность ─────────────────────────────────────────── */

    function imul(a, b) {
        return Math.imul(a, b) >>> 0;
    }

    function rand(g) {
        var s = (g.rng + 0x6D2B79F5) >>> 0;
        g.rng = s;
        var t = imul(s ^ (s >>> 15), s | 1);
        t = (t ^ ((t + imul(t ^ (t >>> 7), t | 61)) >>> 0)) >>> 0;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    }

    function pick(g, list) {
        return list[Math.floor(rand(g) * list.length)];
    }

    /* ─── Партия ──────────────────────────────────────────────── */

    function newGame(seed, level) {
        var g = {
            lv: LEVELS.indexOf(level) >= 0 ? level : 'captain',
            rng: seed >>> 0,
            b: [],
            par: 0,
            win: -1
        };
        var mine = placeFleet(g);
        var theirs = placeFleet(g);
        g.b = [{ s: mine, m: EMPTY }, { s: theirs, m: EMPTY }];
        g.par = Math.floor(rand(g) * 2);
        return g;
    }

    function fresh(g) {
        return g.b[0].m === EMPTY && g.b[1].m === EMPTY;
    }

    function reshuffle(g) {
        if (!fresh(g)) return false;
        g.b[0].s = placeFleet(g);
        return true;
    }

    function placeFleet(g) {
        for (var attempt = 0; attempt < 50; attempt++) {
            var blocked = [];
            for (var z = 0; z < 100; z++) blocked.push(false);
            var ships = [];
            var failed = false;
            for (var f = 0; f < FLEET.length; f++) {
                var len = FLEET[f];
                var cands = [];
                var dirs = len === 1 ? [0] : [0, 1];
                for (var di = 0; di < dirs.length; di++) {
                    var d = dirs[di];
                    for (var r = 0; r < 10; r++) {
                        for (var c = 0; c < 10; c++) {
                            if ((d === 0 && c + len > 10) || (d === 1 && r + len > 10)) continue;
                            var fits = true;
                            for (var k = 0; k < len; k++) {
                                var i = d === 0 ? r * 10 + c + k : (r + k) * 10 + c;
                                if (blocked[i]) { fits = false; break; }
                            }
                            if (fits) cands.push(d * 100 + r * 10 + c);
                        }
                    }
                }
                if (!cands.length) { failed = true; break; }
                var p = pick(g, cands);
                var pd = Math.floor(p / 100), pr = Math.floor((p % 100) / 10), pc = p % 10;
                var cells = [];
                for (var q = 0; q < len; q++) cells.push(pd === 0 ? pr * 10 + pc + q : (pr + q) * 10 + pc);
                ships.push(cells);
                for (var e = 0; e < cells.length; e++) {
                    var cr = Math.floor(cells[e] / 10), cc = cells[e] % 10;
                    for (var dr = -1; dr <= 1; dr++) {
                        for (var dc = -1; dc <= 1; dc++) {
                            var nr = cr + dr, nc = cc + dc;
                            if (nr >= 0 && nr < 10 && nc >= 0 && nc < 10) blocked[nr * 10 + nc] = true;
                        }
                    }
                }
            }
            if (!failed) return ships;
        }
        throw new Error('battleship: no room for the fleet');
    }

    /* ─── Выстрел ─────────────────────────────────────────────── */

    function setMark(b, i, ch) {
        b.m = b.m.substring(0, i) + ch + b.m.substring(i + 1);
    }

    function shipAt(b, i) {
        for (var si = 0; si < b.s.length; si++) {
            if (b.s[si].indexOf(i) >= 0) return si;
        }
        return -1;
    }

    function shoot(b, i, careless) {
        var was = b.m.charAt(i);
        if (careless && was === '+') {
            setMark(b, i, 'o');
            return { r: 'miss', cell: i, was: '+' };
        }
        if (was !== '.') return { r: 'known', cell: i, was: was };
        var si = shipAt(b, i);
        if (si < 0) {
            setMark(b, i, 'o');
            return { r: 'miss', cell: i };
        }
        setMark(b, i, 'x');
        var ship = b.s[si];
        var isSunk = true;
        for (var k = 0; k < ship.length; k++) {
            if (b.m.charAt(ship[k]) !== 'x') { isSunk = false; break; }
        }
        var n, list;
        if (isSunk) {
            for (k = 0; k < ship.length; k++) setMark(b, ship[k], 'X');
            list = around(ship);
            for (n = 0; n < list.length; n++) {
                if (b.m.charAt(list[n]) === '.') setMark(b, list[n], '+');
            }
            return { r: 'sunk', cell: i, ship: si, len: ship.length };
        }
        list = diagonals(i);
        for (n = 0; n < list.length; n++) {
            if (b.m.charAt(list[n]) === '.') setMark(b, list[n], '+');
        }
        return { r: 'hit', cell: i, ship: si };
    }

    function fire(g, i) {
        if (g.win >= 0) return { me: { r: 'over', cell: i }, ai: [] };
        var me = shoot(g.b[1], i);
        var out = { me: me, ai: [] };
        if (me.r === 'sunk' && allSunk(g.b[1])) {
            g.win = 0;
            return out;
        }
        if (me.r === 'miss') out.ai = aiTurn(g);
        return out;
    }

    function aiTurn(g) {
        var events = [];
        while (g.b[0].m.indexOf('.') >= 0) {
            var c = aiPick(g);
            var r = shoot(g.b[0], c, g.lv === 'novice');
            events.push(r);
            if (r.r === 'sunk' && allSunk(g.b[0])) {
                g.win = 1;
                break;
            }
            if (r.r !== 'hit' && r.r !== 'sunk') break;
        }
        return events;
    }

    function allSunk(b) {
        for (var si = 0; si < b.s.length; si++) {
            for (var k = 0; k < b.s[si].length; k++) {
                if (b.m.charAt(b.s[si][k]) !== 'X') return false;
            }
        }
        return true;
    }

    function sunk(b, si) {
        for (var k = 0; k < b.s[si].length; k++) {
            if (b.m.charAt(b.s[si][k]) !== 'X') return false;
        }
        return true;
    }

    function afloat(b) {
        var out = [];
        for (var si = 0; si < b.s.length; si++) {
            if (!sunk(b, si)) out.push(b.s[si].length);
        }
        out.sort(function (x, y) { return y - x; });
        return out;
    }

    function around(cells) {
        var set = {};
        var c, k;
        for (k = 0; k < cells.length; k++) {
            var r = Math.floor(cells[k] / 10), col = cells[k] % 10;
            for (var dr = -1; dr <= 1; dr++) {
                for (var dc = -1; dc <= 1; dc++) {
                    var nr = r + dr, nc = col + dc;
                    if (nr >= 0 && nr < 10 && nc >= 0 && nc < 10) set[nr * 10 + nc] = true;
                }
            }
        }
        for (k = 0; k < cells.length; k++) delete set[cells[k]];
        var out = [];
        for (c = 0; c < 100; c++) if (set[c]) out.push(c);
        return out;
    }

    function diagonals(i) {
        var r = Math.floor(i / 10), c = i % 10, out = [];
        var dd = [[-1, -1], [-1, 1], [1, -1], [1, 1]];
        for (var k = 0; k < dd.length; k++) {
            var nr = r + dd[k][0], nc = c + dd[k][1];
            if (nr >= 0 && nr < 10 && nc >= 0 && nc < 10) out.push(nr * 10 + nc);
        }
        return out;
    }

    /* ─── Соперник ────────────────────────────────────────────── */

    function aiPick(g) {
        var m = g.b[0].m;
        var groups = woundedGroups(m);
        var lv = g.lv;
        var i;

        if (lv === 'admiral') return admiralPick(g, groups);
        if (groups.length) {
            if (lv === 'captain' || rand(g) < 0.5) {
                var cands = targetCells(m, groups[0]);
                if (cands.length) return pick(g, cands);
            }
        }
        if (lv === 'novice' && rand(g) < NOVICE_CARELESS) {
            var any = [];
            for (i = 0; i < 100; i++) {
                if (m.charAt(i) === '.' || m.charAt(i) === '+') any.push(i);
            }
            return pick(g, any);
        }
        if (lv === 'captain') {
            var hunt = [];
            for (i = 0; i < 100; i++) {
                if (m.charAt(i) === '.' && ((Math.floor(i / 10) + i % 10) % 2) === g.par) hunt.push(i);
            }
            if (hunt.length) return pick(g, hunt);
        }
        return pick(g, unknown(m));
    }

    function unknown(m) {
        var out = [];
        for (var i = 0; i < 100; i++) if (m.charAt(i) === '.') out.push(i);
        return out;
    }

    function woundedGroups(m) {
        var seen = {};
        var groups = [];
        for (var i = 0; i < 100; i++) {
            if (m.charAt(i) !== 'x' || seen[i]) continue;
            seen[i] = true;
            var stack = [i];
            var grp = [];
            while (stack.length) {
                var c = stack.pop();
                grp.push(c);
                var ns = orth(c);
                for (var k = 0; k < ns.length; k++) {
                    if (m.charAt(ns[k]) === 'x' && !seen[ns[k]]) {
                        seen[ns[k]] = true;
                        stack.push(ns[k]);
                    }
                }
            }
            grp.sort(function (x, y) { return x - y; });
            groups.push(grp);
        }
        return groups;
    }

    function orth(i) {
        var r = Math.floor(i / 10), c = i % 10, out = [];
        if (r > 0) out.push(i - 10);
        if (c > 0) out.push(i - 1);
        if (c < 9) out.push(i + 1);
        if (r < 9) out.push(i + 10);
        return out;
    }

    function targetCells(m, grp) {
        var out = [];
        if (grp.length >= 2) {
            var first = grp[0], last = grp[grp.length - 1];
            if (Math.floor(first / 10) === Math.floor(last / 10)) {
                if (first % 10 > 0 && m.charAt(first - 1) === '.') out.push(first - 1);
                if (last % 10 < 9 && m.charAt(last + 1) === '.') out.push(last + 1);
            } else {
                if (Math.floor(first / 10) > 0 && m.charAt(first - 10) === '.') out.push(first - 10);
                if (Math.floor(last / 10) < 9 && m.charAt(last + 10) === '.') out.push(last + 10);
            }
            return out;
        }
        var ns = orth(grp[0]);
        for (var k = 0; k < ns.length; k++) if (m.charAt(ns[k]) === '.') out.push(ns[k]);
        return out;
    }

    function admiralPick(g, groups) {
        var b = g.b[0];
        var m = b.m;
        var count = { 1: 0, 2: 0, 3: 0, 4: 0 };
        var fl = afloat(b);
        var i, k;
        for (k = 0; k < fl.length; k++) count[fl[k]]++;
        var target = groups.length ? groups[0] : null;
        var inTarget = {};
        if (target) for (k = 0; k < target.length; k++) inTarget[target[k]] = true;

        var score = [];
        for (i = 0; i < 100; i++) score.push(0);
        var lens = [4, 3, 2, 1];
        for (var li = 0; li < lens.length; li++) {
            var len = lens[li];
            var n = count[len];
            if (n === 0 || (target && len <= target.length)) continue;
            var dirs = len === 1 ? [0] : [0, 1];
            for (var di = 0; di < dirs.length; di++) {
                var d = dirs[di];
                for (var r = 0; r < 10; r++) {
                    for (var c = 0; c < 10; c++) {
                        if ((d === 0 && c + len > 10) || (d === 1 && r + len > 10)) continue;
                        var ok = true, hits = 0;
                        for (k = 0; k < len; k++) {
                            i = d === 0 ? r * 10 + c + k : (r + k) * 10 + c;
                            var ch = m.charAt(i);
                            if (ch === '.') continue;
                            if (ch === 'x' && inTarget[i]) { hits++; continue; }
                            ok = false;
                            break;
                        }
                        if (!ok || (target && hits !== target.length)) continue;
                        for (k = 0; k < len; k++) {
                            i = d === 0 ? r * 10 + c + k : (r + k) * 10 + c;
                            if (m.charAt(i) === '.') score[i] += n;
                        }
                    }
                }
            }
        }

        var best = 0;
        for (i = 0; i < 100; i++) if (m.charAt(i) === '.' && score[i] > best) best = score[i];
        if (best === 0) return pick(g, unknown(m));
        var cands = [];
        for (i = 0; i < 100; i++) if (m.charAt(i) === '.' && score[i] === best) cands.push(i);
        return pick(g, cands);
    }

    var api = {
        FLEET: FLEET,
        LEVELS: LEVELS,
        NOVICE_CARELESS: NOVICE_CARELESS,
        rand: rand,
        pick: pick,
        newGame: newGame,
        fresh: fresh,
        reshuffle: reshuffle,
        placeFleet: placeFleet,
        shipAt: shipAt,
        shoot: shoot,
        fire: fire,
        aiTurn: aiTurn,
        aiPick: aiPick,
        allSunk: allSunk,
        sunk: sunk,
        afloat: afloat,
        around: around,
        diagonals: diagonals,
        unknown: unknown,
        woundedGroups: woundedGroups,
        targetCells: targetCells
    };

    if (typeof module === 'object' && module && module.exports) module.exports = api;
    root.BattleshipEngine = api;
})(typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : this));
